import React, { Component } from 'react'
import { InputGroup, Label, Input, Button, } from 'reactstrap'
import { BeatLoader } from 'react-spinners'
import { ErrorMessage } from './'
import validatePassword from '../../../../../../helpers/users/manageUsers/validatePassword';
import overridePassword from '../../../../../../helpers/users/manageUsers/overridePassword';

class PasswordOverride extends Component {
  state = {
    saving: false,
    saved: false,
    password: '',
    error: '',
    changed: false,
  }

  handleChange = ({target}) => this.setState({password: target.value, changed: true, saved: false})
  
  overridePW = () => {
    const { password } = this.state
    const { record } = this.props
    this.setState({saving: true})
    const validationError = validatePassword(password)
    if (validationError) {
      this.setState({saving: false, error: validationError})
    } else {
      overridePassword(record, password)
        .then(() => this.setState({
          saving: false, 
          saved: true, 
          changed: false, 
          error: '', 
          password: ''
        }))
        .catch(err => this.setState({
          error: 'Error saving password.', 
          saving: false, 
          saved: false, 
          changed: true
        }))
    }
  }

  render() {
    const { password, saving, saved, error, changed } = this.state
    const { record, cancelOverride } = this.props
    return (
      <InputGroup>
        <Label htmlFor='passwordOverride'>New Password:</Label>
        <Input
          type='text'
          value={password}
          onChange={this.handleChange}
          name='passwordOverride'
          id='passwordOverride'
        />
        <Button 
          disabled={!(changed) || !!saved}
          onClick={this.overridePW}  
        >
          {saving
            ? <BeatLoader loading={saving} />
            : (saved ? 'Saved' : 'Save')
          }
        </Button>
        <Button 
          disabled={!!saving} 
          onClick={cancelOverride}
        >
          Cancel
        </Button>
        {error
          ? <ErrorMessage>{error}</ErrorMessage>
          : null
        }
      </InputGroup>
    )
  }
}

export default PasswordOverride


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManagePane/InfoCard/ActionBlockComponents/PasswordOverride.js